const languageDropdown = [
  { name: "English", lngValue: "en" },
  { name: "עִברִית", lngValue: "he" },
];

const agronomistTableHeader = [
  {
    name: "Full name",
  },
  {
    name: "Email Address",
  },
  {
    name: "Location",
  },
  {
    name: "Status",
  },
  {
    name: "Action",
  },
];
const cropTableHeader = [
  {
    name: "Name",
  },
  {
    name: "Status",
  },
  {
    name: "Action",
  },
];
const productTableHeader = [
  {
    name: "Product name",
  },
  {
    name: "Product Rate",
  },
  {
    name: "Status",
  },
  {
    name: "Action",
  },
];

const containerTypeTableHeader = [
  {
    name: "Type name",
  },
  {
    name: "Action",
  },
];

const dataCountOption = [
  {
    id: "1",
    page: "5",
  },
  {
    id: "2",
    page: "10",
  },
  {
    id: "3",
    page: "20",
  },
  {
    id: "4",
    page: "30",
  },
];
const growerTableHeader = [
  {
    name: "Full name",
  },
  {
    name: "Email Address",
  },
  {
    name: "Location",
  },

  {
    name: "Action",
  },
];
const scoutingTableHeader = [
  {
    name: "Fields",
  },

  {
    name: "Year",
  },

  {
    name: "Action",
  },
];
const scoutingModalHeader = (year) => {
  return [
    {
      name: "Field",
    },
    {
      name: `Crop ${year}`,
    },
    {
      name: "Acres",
    },
    {
      name: "Select",
    },
  ];
};
const cropPlanTableHeader = [
  {
    name: "Growing Session",
  },
  { name: "Description" },
  // { name: "Status" },
  {
    name: "Action",
  },
];
const scoutingModalStep2Header = [
  {
    name: "Field",
  },
  {
    name: "Crop",
  },
  {
    name: "Acres",
  },
];

export {
  languageDropdown,
  agronomistTableHeader,
  dataCountOption,
  productTableHeader,
  growerTableHeader,
  cropTableHeader,
  scoutingTableHeader,
  scoutingModalHeader,
  cropPlanTableHeader,
  scoutingModalStep2Header,
  containerTypeTableHeader,
};
